import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Glyphicon, OverlayTrigger, Tooltip } from '@bingads-webui-react/primitive';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { withOverflowProp } from '@bingads-webui-react/with-overflow-prop';

export const OverflowContent = withOverflowProp(({
  text,
  isTextOverflow,
  forwardedRef,
  tooltipPlacement,
  entityClassName = 'entity-text',
  href = null,
  ...passBy
}) => (
  <OverlayTrigger
    key={tooltipPlacement}
    placement={tooltipPlacement}
    overlay={
      <Tooltip
        id={tooltipPlacement}
        className={isTextOverflow ? '' : 'hide'}
      >
        {text}
      </Tooltip>
    }
  >
    { href ? (<a className={entityClassName} href={href} ref={forwardedRef} {...passBy}>{text}</a>) :
     (<span className={entityClassName} ref={forwardedRef} {...passBy}>{text}</span>) }
  </OverlayTrigger>));

export const OverflowEntityItem = ({
  canEdit,
  label,
  text,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onClick,
  ariaLabel,
  tooltipPlacement,
  renderContent,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  siteMap,
  className,
  ...others
}) => (
  <div
    className={classNames('overflow-item', 'menu-item', className, canEdit && 'editable')}
    aria-label={ariaLabel}
  >
    <Glyphicon
      className="entity-icon"
      glyph="ba-Edit"
    />
    <OverflowContent text={label} tooltipPlacement={tooltipPlacement} entityClassName="entity-label" />
    {renderContent ? renderContent({ canEdit: false, ...others }) : (<OverflowContent text={text} tooltipPlacement={tooltipPlacement} />)}
  </div>);

OverflowEntityItem.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string,
  onClick: PropTypes.func,
  canEdit: PropTypes.bool,
  ariaLabel: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  renderContent: PropTypes.func,
  className: PropTypes.string,
  siteMap: siteMapPropType.isRequired,
};

OverflowEntityItem.defaultProps = {
  onClick: null,
  canEdit: true,
  ariaLabel: '',
  text: '',
  tooltipPlacement: 'top',
  renderContent: null,
  className: '',
};
